import { render, staticRenderFns } from "./ProjectsView.vue?vue&type=template&id=59a50ed1&scoped=true&"
import script from "./ProjectsView.vue?vue&type=script&lang=js&"
export * from "./ProjectsView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsView.vue?vue&type=style&index=0&id=59a50ed1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a50ed1",
  null
  
)

export default component.exports